import { render, staticRenderFns } from "./PendingModal.vue?vue&type=template&id=12da548f&scoped=true"
import script from "./PendingModal.vue?vue&type=script&lang=js"
export * from "./PendingModal.vue?vue&type=script&lang=js"
import style0 from "./PendingModal.vue?vue&type=style&index=0&id=12da548f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da548f",
  null
  
)

export default component.exports